module.exports = __webpack_public_path__ + "media/shuileyuan.eabdc1ab.mp3";